import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getGateMarkAvailableColumns } from './api';

export const path = '/calculator-tariff/gate-mark/list';

const PageGateMarks: React.FC = (props) => {
  const GateMarks = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getGateMarkAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <GateMarks {...props} />;
};

export default PageGateMarks;
